<template>
  <div
    class="w-screen md:max-w-(--breakpoint-xl) flex-col md:flex-row m-auto flex section-y"
  >
    <div
      class="px-4"
      :class="[
        content?.image?.data?.url ? 'w-full md:w-1/2 mb-6 md:mb-0' : 'w-full',
        content.imagePosition === 'right'
          ? 'order-first'
          : 'order-first md:order-last',
      ]"
    >
      <h2 class="section-title mb-2">{{ content?.title }}</h2>
      <vue-markdown
        v-if="content?.text"
        class="prose max-w-none w-full"
        :source="content?.text || ''"
      />

      <div v-if="content?.cta?.length > 0" class="flex gap-2 grow mt-3">
        <Button
          v-for="button in content?.cta"
          :key="button?.label"
          :link="button?.url"
          @click="handleCTA(button?.url)"
        >
          {{ button?.label }}
        </Button>
      </div>
    </div>
    <div
      v-if="content?.image?.data?.url"
      class="w-full md:w-1/2 px-4"
      :class="[
        content.imagePosition === 'right'
          ? 'order-last'
          : 'order-last md:order-first',
      ]"
    >
      <img :src="content?.image?.data?.url" alt="" loading="lazy" />
    </div>
  </div>
</template>
<script setup lang="ts">
import VueMarkdown from 'vue-markdown-render'

const { toggleDateRequestSidebar } = useUiState()
const route = useRoute()
const emit = defineEmits(['openContactForm', 'openCaseStudyForm'])

const { content = {} } = defineProps<{ content: any }>()

const handleCTA = (action: string) => {
  if (action === 'openEventRequestForm') {
    toggleDateRequestSidebar(route.name?.toString(), 'strapi_component')
  } else if (action === 'openPartnerContactForm') {
    emit('openContactForm')
  } else if (action === 'openCaseStudyForm') {
    emit('openCaseStudyForm')
  }
}
</script>

<style scoped lang="css"></style>
